import { PaginationResponse } from './../responses/PaginationResponse';
import { AccountHistoryItem, UpvestReportDocument } from '../models';
import { HttpHeader } from '../utils/HttpHeader';
import { HttpRequester } from '../utils/HttpRequester';
import { Urls } from "../utils/Urls";
import { TokenService } from './TokenService';
import { UpvestAccountHistoryRequest } from '../requests';
export class UpvestAccountHistoryService {
    private static links = Urls.URLS();
    private static requester = HttpRequester.httpRequester();
    private static headers = new HttpHeader();
    constructor() {
        // Initialization code here
    }
    public static async getAccountHistory(request:UpvestAccountHistoryRequest): Promise<PaginationResponse<AccountHistoryItem>> {
        try {
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            let json = await this.requester.get(this.links.getUpvestAccountHistory(request.upvestUserId,request.page,request.perPage,request.startdate,request.enddate,request.type), this.headers);
            let response:PaginationResponse<AccountHistoryItem> = {
                        data:json.data,
                        currentPage:Math.floor(json.meta.offset/json.meta.limit)+1,
                        lastPage:Math.ceil(json.meta.total_count/json.meta.limit),
                        total:Math.ceil(json.meta.total_count/json.meta.limit)
                    };
            return response;
        }
        catch (err) {
            throw err;
        }
    }
    public static async getAccountHistoryReport(reportId:string): Promise<UpvestReportDocument> {
        try {
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            let json = await this.requester.get(this.links.getUpvestAccountHistoryReport(reportId), this.headers);
            let response:UpvestReportDocument = json.data;
            return response;
        }
        catch (err) {
            throw err;
        }
    }
    
}